import { Position, Toaster } from "@blueprintjs/core"

export function makeToast(message, indicator, action) {
    const toastType = {
        primary: "pt-intent-primary",
        success: "pt-intent-success",
        warning: "pt-intent-warning",
        danger:  "pt-intent-danger",
    }
    const timeout = action ? 0 : 3000
    const toastAction = action ? action : null
    const myToast = Toaster.create({ position: Position.TOP})
    const indType = toastType[indicator] ? toastType[indicator] : toastType["success"]
    myToast.show({
        message: message,
        className: `${indType} onTop`,
        timeout,
        action: toastAction,
    })
}


// WEBPACK FOOTER //
// ./src/util/toast_util.js